var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReverse = function SvgReverse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M4.72 19.78a.75.75 0 0 0 1.06-1.06L2.56 15.5h14.69a.75.75 0 1 0 0-1.5H2.56l3.22-3.22a.749.749 0 1 0-1.06-1.06l-4.5 4.5a.75.75 0 0 0 0 1.06zm8.56-9.5a.75.75 0 1 1-1.06-1.06L15.44 6H.75a.75.75 0 0 1 0-1.5h14.69l-3.22-3.22A.75.75 0 0 1 13.28.22l4.5 4.5a.75.75 0 0 1 0 1.06z"
  })));
};
export default SvgReverse;